import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, MapPin, Phone, Mail } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="border-t border-slate-200 bg-white" itemScope itemType="https://schema.org/Organization">
      <meta itemProp="name" content="ProsoftMarketplace" />
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 gap-8 lg:grid-cols-5">
          <div className="col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center bg-emerald-500">
                <ShieldCheck className="h-5 w-5 text-slate-900" strokeWidth={2.5} />
              </span>
              <span className="font-display text-lg font-black tracking-tight text-slate-900">
                PROSOFT <span className="text-emerald-600">MARKETPLACE</span>
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm text-slate-600">
              Independent reseller of Huntheal Antivirus for Windows PCs. Simple pricing,
              instant PayPal checkout, 30-day money-back guarantee.
            </p>

            <address
              className="mt-6 not-italic"
              itemProp="address"
              itemScope
              itemType="https://schema.org/PostalAddress"
            >
              <div className="flex items-start gap-2 text-sm text-slate-700">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-emerald-500" />
                <div>
                  <span itemProp="streetAddress">2118 Glenridge Ct</span>,&nbsp;
                  <span itemProp="addressLocality">Marietta</span>,&nbsp;
                  <span itemProp="addressRegion">GA</span>&nbsp;
                  <span itemProp="postalCode">30062</span>
                  <meta itemProp="addressCountry" content="US" />
                </div>
              </div>
              <a
                href="tel:+18886554464"
                data-testid="footer-phone-link"
                className="mt-2 flex items-center gap-2 text-sm font-bold text-slate-900 hover:text-emerald-600"
                itemProp="telephone"
              >
                <Phone className="h-4 w-4 text-emerald-500" />
                +1 (888) 655-4464
              </a>
              <a
                href="mailto:support@prosoftmarketplace.com"
                data-testid="footer-email-link"
                className="mt-2 flex items-center gap-2 text-sm text-slate-700 hover:text-slate-900"
                itemProp="email"
              >
                <Mail className="h-4 w-4 text-emerald-500" />
                support@prosoftmarketplace.com
              </a>
            </address>

            <div className="mt-6 inline-flex items-center gap-2 border border-slate-200 px-3 py-1.5 text-xs font-bold uppercase tracking-[0.2em] text-slate-700">
              <span className="h-2 w-2 bg-emerald-500" /> Secured checkout
            </div>
          </div>

          <FooterCol
            title="Product"
            links={[
              { to: "/products/huntheal-antivirus-pc", label: "Huntheal Antivirus" },
              { to: "/products/huntheal-antivirus-pc", label: "1 PC — $34.95" },
              { to: "/products/huntheal-antivirus-pc", label: "3 PCs — $39.95" },
              { to: "/products/huntheal-antivirus-pc", label: "5 PCs — $44.95" },
            ]}
          />
          <FooterCol
            title="Company"
            links={[
              { to: "/blog", label: "Blog" },
              { to: "/support", label: "Support" },
              { to: "/contact", label: "Contact" },
              { to: "/refund-policy", label: "Refund Policy" },
            ]}
          />
          <FooterCol
            title="Help"
            links={[
              { to: "/blog", label: "Blog" },
              { to: "/support", label: "Support" },
              { to: "/contact", label: "Contact" },
              { to: "/refund-policy", label: "Refund Policy" },
              { to: "/privacy", label: "Privacy" },
            ]}
          />
        </div>

        <div className="mt-12 border-t border-slate-200 pt-6 text-xs text-slate-500">
          <p className="max-w-4xl leading-relaxed">
            <span className="font-bold uppercase tracking-[0.15em] text-slate-700">Disclaimer:</span> ProsoftMarketplace
            is an independent reseller. Huntheal is a trademark of its respective owner. All other
            brand names and trademarks referenced anywhere on this site are the property of their
            respective owners. We are not affiliated with, endorsed by, or partnered with any brand
            unless explicitly specified.
          </p>
          <div className="mt-4 flex flex-col items-start justify-between gap-2 sm:flex-row sm:items-center">
            <div>© {new Date().getFullYear()} ProsoftMarketplace. Independent cybersecurity reseller.</div>
            <div className="font-mono uppercase tracking-[0.2em]">v1.0 · 256-bit TLS</div>
          </div>
        </div>
      </div>
    </footer>
  );
};

const FooterCol = ({ title, links }) => (
  <div>
    <div className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
      {title}
    </div>
    <ul className="mt-4 space-y-2">
      {links.map((l, i) => (
        <li key={i}>
          <Link
            to={l.to}
            className="text-sm text-slate-700 transition-colors hover:text-slate-900"
          >
            {l.label}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);
